module.exports = __webpack_public_path__ + "static/img/qmwallet2-price.0d91da65.png";